import React, { Suspense } from 'react'
import './App.css'
import { Navbar } from './components/Navbar.jsx'
import Header from './components/Header.jsx'
import Championship from './components/Championship'
import Competition from './components/Competitions'
import Video from './components/Video'
import Tournament from './components/Tournaments'
import { Footer } from './components/Footer'

function App() {
	return (
		<Suspense fallback='loading'>
			<Navbar />
			<Header />
			<Championship />
			<Competition />
			<Video />
			<Tournament />
			<Footer />
		</Suspense>
	)
}

export default App
